/* Fransk katalog for locale-autopilot-year-end-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'ap.yearEnd.title': 'Clôture annuelle {{year}}',
  'ap.yearEnd.progress': 'Avancement de la clôture annuelle',
  'ap.yearEnd.step.summary': 'Récapitulatif',
  'ap.yearEnd.step.review': 'Clarifications',
  'ap.yearEnd.step.additions': 'Ajouts',
  'ap.yearEnd.step.final': 'Approuver',
  'ap.yearEnd.step.submission': 'Dépôt',
  'ap.yearEnd.summaryTitle': 'J\'ai contrôlé la base annuelle',
  'ap.yearEnd.summaryText': 'Vous n\'avez à traiter que les points qui ne peuvent pas être clarifiés de façon sûre à partir des données de Plumme.',
  'ap.yearEnd.approved': 'Contrôlé et en ordre',
  'ap.yearEnd.notApplicable': 'Sans objet',
  'ap.yearEnd.needsYou': 'À traiter',
  'ap.yearEnd.startReview': 'Traiter {{count}} points',
  'ap.yearEnd.continueAdditions': 'Continuer vers les ajouts',
  'ap.yearEnd.questionCount': '{{total}} points restants',
  'ap.yearEnd.startReviewGroups': 'Traiter {{count}} groupes',
  'ap.yearEnd.groupCount': '{{total}} groupes restants',
  'ap.yearEnd.confirmReviewed': 'J\'ai contrôlé et je confirme',
  'ap.yearEnd.changeSomething': 'Je dois modifier quelque chose',
  'ap.yearEnd.openWorkArea': 'Ouvrir l\'espace de travail concerné',
  'ap.yearEnd.askAboutThis': 'Interroger l\'IA à ce sujet',
  'ap.yearEnd.handleCheck': 'Traiter',
  'ap.yearEnd.backToFlow': 'Retour à la clôture annuelle',
  'ap.yearEnd.openAsPage': 'Ouvrir dans une page dédiée',
  'ap.yearEnd.workAreaNote': 'Les points de contrôle sont mis à jour en fonction de ce que vous faites ici.',
  'ap.yearEnd.reviewDone': 'Tous les points de contrôle sont clarifiés',
  'ap.yearEnd.reviewDoneText': 'Nous vérifions maintenant si vous disposez d\'autres informations qui ne figurent pas dans Plumme.',
  'ap.yearEnd.completeness': 'Contrôle d\'exhaustivité',
  'ap.yearEnd.anythingElse': 'Y a-t-il autre chose à ajouter ?',
  'ap.yearEnd.anythingElseText': 'Décrivez-le avec vos propres mots. L\'IA vous aide à trouver le bon domaine, mais ne modifie rien tant que vous n\'avez pas contrôlé et approuvé la proposition.',
  'ap.yearEnd.additionPlaceholder': 'Par exemple : nous avons acheté une camionnette en décembre, mais la facture est arrivée en janvier.',
  'ap.yearEnd.findAddition': 'Trouver l\'ajout approprié',
  'ap.yearEnd.showAllAdditions': 'Afficher tous les ajouts',
  'ap.yearEnd.noMore': 'Non, je n\'ai rien d\'autre à ajouter',
  'ap.yearEnd.finalControl': 'Contrôle final',
  'ap.yearEnd.readyTitle': 'La clôture annuelle est prête à être approuvée',
  'ap.yearEnd.result': 'Résultat de l\'exercice',
  'ap.yearEnd.backToReview': 'Traiter les points restants',
  'ap.yearEnd.completeAdditions': 'Terminer le contrôle des ajouts',
  'ap.yearEnd.closeYear': 'Approuver et clôturer l\'exercice',
  'ap.yearEnd.closing': 'Clôture en cours …',
  'ap.yearEnd.closedToast': 'L\'exercice a été clôturé.',
  'ap.yearEnd.saveError': 'Impossible d\'enregistrer la clôture annuelle.',
  'ap.yearEnd.closeError': 'Impossible de clôturer l\'exercice.',
  'ap.yearEnd.submissionTitle': 'L\'exercice est clôturé',
  'ap.yearEnd.filedTitle': 'La clôture annuelle est terminée',
  'ap.yearEnd.submissionText': 'Poursuivez avec la skattemelding et les comptes annuels. Les modifications ultérieures se font pour l\'instant dans la vue complète.',
  'ap.yearEnd.ai.title': 'Demander à SuperPlumma',
  'ap.yearEnd.ai.context': 'La conversation porte sur cette clôture annuelle et ce point de contrôle.',
  'ap.yearEnd.ai.empty': 'Demandez pourquoi le point est pertinent, ce que signifie un terme, ou décrivez quelque chose qui, selon vous, manque.',
  'ap.yearEnd.ai.placeholder': 'Que souhaitez-vous savoir ?',
  'ap.yearEnd.ai.ask': 'Demander',
  'ap.yearEnd.ai.thinking': 'Vérification …',
  'ap.yearEnd.ai.error': 'Impossible d\'obtenir une explication pour le moment.',
  'ap.yearEnd.ai.noAnswer': 'Je n\'ai pas trouvé de réponse sûre. Ouvrez la vue complète pour contrôler manuellement.',
  'ap.yearEnd.ai.proposalTitle': 'Proposition de poste fiscal',
  'ap.yearEnd.ai.assetGroup': 'Groupe d\'amortissement fiscal (saldogruppe)',
  'ap.yearEnd.ai.description': 'Description',
  'ap.yearEnd.ai.openingValue': 'Valeur d\'ouverture',
  'ap.yearEnd.ai.acquisition': 'Nouvelle acquisition',
  'ap.yearEnd.ai.improvement': 'Dépense d\'amélioration',
  'ap.yearEnd.ai.proceeds': 'Prix de cession',
  'ap.yearEnd.ai.depreciation': 'Amortissement',
  'ap.yearEnd.ai.amount': 'Montant',
  'ap.yearEnd.ai.bookPrevious': 'Valeur comptable l\'an dernier',
  'ap.yearEnd.ai.taxPrevious': 'Valeur fiscale l\'an dernier',
  'ap.yearEnd.ai.bookCurrent': 'Valeur comptable cette année',
  'ap.yearEnd.ai.taxCurrent': 'Valeur fiscale cette année',
  'ap.yearEnd.ai.approvalNote': 'Rien n\'est enregistré avant votre approbation. Le poste est de nouveau validé lors de l\'enregistrement.',
  'ap.yearEnd.ai.approve': 'Approuver et ajouter',
  'ap.yearEnd.ai.saved': 'Le poste fiscal a été ajouté au brouillon. Vous pouvez décrire d\'autres informations si quelque chose d\'autre manque.',
  'ap.yearEnd.ai.savedToast': 'Poste fiscal ajouté',
  'ap.yearEnd.ai.saveError': 'Impossible d\'enregistrer le poste fiscal.',
  'ap.yearEnd.ai.draftInProgress': 'Proposition en cours',
  'ap.yearEnd.ai.cancelDraft': 'Terminer',
  'ap.agentName.bookkeeping': 'Agent de comptabilité',
  'ap.agentName.tax': 'Agent fiscal',
  'ap.agentName.annual': 'Agent des comptes annuels',
  'ap.followup.bank': 'Rapprochement bancaire',
  'ap.followup.title': 'Suivi',
  'ap.followup.countOne': '{{count}} point nécessite un suivi.',
  'ap.followup.countMany': '{{count}} points nécessitent un suivi.',
  'ap.agent.tax.titleMissing': '{{count}} prérequis manquants avant la skattemelding',
  'ap.agent.annual.titleMissing': '{{count}} prérequis manquants avant les comptes annuels',
  'ap.readiness.yearOpen': 'L\'exercice n\'est pas clôturé',
  'ap.readiness.yearOpenSub': 'La clôture annuelle n\'a pas été effectuée',
  'ap.readiness.inbox': '{{count}} justificatifs ne sont pas entièrement traités',
  'ap.readiness.inboxSub': 'Terminez la boîte de réception avant le dépôt annuel',
  'ap.readiness.bank': '{{count}} lignes bancaires ne sont pas entièrement rapprochées',
  'ap.readiness.bankSub': 'Terminez le rapprochement bancaire',
  'ap.readiness.previousTax': 'Le dépôt de la skattemelding précédente n\'a pas été confirmé',
  'ap.readiness.reviewYear': 'Contrôler {{year}}',
  'ap.review.all': 'Tous',
  'ap.review.withVoucher': 'Avec justificatif',
  'ap.review.matched': 'Rapproché',
  'ap.review.missingVoucher': 'Justificatif manquant',
  'ap.review.needsChecking': 'À contrôler',
  'ap.review.createsDeviation': 'Crée un écart',
  'ap.review.upToDate': 'À jour',
  'ap.review.approvedNotPosted': 'Approuvé · non comptabilisé',
  'ap.review.blocked': 'Bloqué',
  'ap.review.ready': 'Prêt',
  'ap.review.yourAccounts': 'Votre comptabilité',
  'ap.review.exampleData': 'Données d\'exemple',
  'ap.review.voucherLinked': '✓ Justificatif associé',
  'ap.review.hideVoucher': 'Masquer le justificatif',
  'ap.review.showVoucher': 'Afficher le justificatif',
  'ap.review.allVouchersLinked': 'Tous les justificatifs sont associés 🎉',
  'ap.review.deadline': 'Échéance',
  'ap.review.readyForApproval': 'Prêt pour approbation',
  'ap.surface.fullscreen': 'Afficher en plein écran',
  'ap.surface.exitFullscreen': 'Quitter le plein écran',
  'ap.surface.voucherCount': '{{count}} justificatifs',
  'ap.surface.outsideMonth': '{{count}} hors du mois',
  'ap.surface.accountsAndVouchers': 'Comptes et justificatifs sans ligne bancaire',
  'ap.yearEnd.bank.title': 'Rapprochement bancaire {{year}}',
  'ap.yearEnd.bank.note': 'Choisissez le mois à contrôler pour cette clôture annuelle.',
  'ap.yearEnd.bank.openLines': '{{count}} lignes bancaires ouvertes',
  'ap.yearEnd.bank.missingStatements': '{{count}} comptes bancaires sans relevé',
  'ap.yearEnd.bank.done': 'Rapproché et archivé',
  'ap.yearEnd.bank.needsArchive': 'Vérifier l\'archivage',
  'ap.yearEnd.bank.noStatement': 'Aucun relevé bancaire',
  'ap.yearEnd.backToWorkArea': 'Retour à {{title}}',
  'ap.surface.bankUploadUnavailable': 'Le téléversement de relevés bancaires n\'est pas encore disponible.',
  'ap.surface.bankReadError': 'Impossible de lire le relevé bancaire.',
  'ap.surface.bankLoadErrorTitle': 'Impossible de charger le rapprochement',
  'ap.surface.bankLoadErrorDetail': 'Rechargez la page ou ouvrez le relevé depuis Banque.',
  'ap.surface.assetMovedToExpense': 'Le justificatif a été retiré du contrôle des immobilisations. Vérifiez le compte et la TVA dans la liste de comptabilisation.',
  'ap.surface.assetSkipError': 'Impossible d\'ignorer l\'enregistrement de l\'immobilisation.',
  'ap.surface.assetTitle': 'Immobilisations possibles',
  'ap.surface.assetSubtitle': '{{count}} justificatifs au-dessus du seuil',
  'ap.surface.assetEmptyTitle': 'Plus aucune suggestion d\'immobilisation',
  'ap.surface.assetChooseHelp': 'Choisissez si le justificatif doit être enregistré comme immobilisation ou renvoyé au contrôle comptable habituel. L\'achat n\'est comptabilisé qu\'une seule fois.',
  'ap.surface.assetNotAsset': 'Pas une immobilisation',
  'ap.surface.inboxTitle': 'Boîte de réception des justificatifs',
});
